import { type PrimitiveType, useIntl } from 'react-intl';

import enMessages from '../translations/en-US';
import { type MessageKey, type Translator } from '../translations/translation-types';

export const useTranslation = (): { t: Translator } => {
	const intl = useIntl();

	const t: Translator = <K extends MessageKey>(
		key: K,
		options: Record<string, PrimitiveType> = {}
	): string =>
		intl.formatMessage(
			{ id: key, defaultMessage: enMessages[key] },
			{
				...options,
				b: (...chunks) => `<strong>${chunks.join('')}</strong>`,
			}
		);

	return { t };
};
